module.exports = __webpack_public_path__ + "img/20200104131641360截图20200104102241601.0e8531e2.jpg";